/**
 * 로그인/회원가입 플로우 공통 쉘.
 * - 화면 높이 100% 확보 → 하단 액션 버튼 sticky 하단 배치
 */
export default function AuthShell({ children, className = '' }) {
  return (
    <section
      className={`relative flex h-full min-h-[100dvh] w-full flex-col bg-[#F0EAF7] font-['Pretendard'] text-black ${className}`}
    >
      {children}
    </section>
  );
}

/**
 * 가입 단계 공통 레이아웃: 본문 스크롤 + 하단 고정 액션 영역
 */
export function AuthOnboardingLayout({ header, children, actions, className = '' }) {
  return (
    <AuthShell className={className}>
      <div className="flex h-full min-h-[100dvh] flex-col px-[10px] pt-2">
        {header}
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain pb-4">{children}</div>
        {actions ? <div className="shrink-0 px-0 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-3">{actions}</div> : null}
      </div>
    </AuthShell>
  );
}
